// extracted by mini-css-extract-plugin
export var root = "l_pq";
export var wrapper = "l_pr";
export var image = "l_ps f_bz f_bC f_bZ";
export var crop = "l_pt";
export var round = "l_pv";
export var fixedHeight = "l_pw";